/* eslint-disable arrow-parens */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Highlight from 'react-highlight.js'
import { Form, Checkbox, Row, Col } from 'antd'
import TestSnippet from './TestSnippet'
import ApptTypeSelection from './ApptTypeSelection'
import BrandName from './BrandName'
import ExtraQuestions from './ExtraQuestions'
import SpecificLocations from './SpecificLocations'
import CopyButton from './CopyButton'
import TextAreaLabel from './TextAreaLabel'
import OptionalMessageInWidget from './OptionalMessageInWidget'
import CustomTimeBounds from './CustomTimeBounds'

import {
  addFilterOptionButton,
  buildBrandNameStr,
  buildCustomTimeBoundsStr,
  buildExtraQuestionsStr,
  buildFilterObjStr,
  buildOptionsStr,
  buildSelectedLocationsStr,
  buildTextAreaLabelStr,
  buildWidgetCode,
  createDeepCopy,
  defaultApptTypeFilterOptions,
  defaultExtraQuestion,
  defaultWidgetOptions,
  messageInWidgetOptions,
} from './utils'

import css from './styles.css'
import formCss from '../../../common/Form.css'
import * as req from '../../../common/requests'

class SchedulingWidgetSnippet extends Component {
  static propTypes = {
    appointmentTypes: PropTypes.arrayOf(PropTypes.object),
    locations: PropTypes.arrayOf(PropTypes.object),
    practiceId: PropTypes.string.isRequired,
    website: PropTypes.string,
  }

  static defaultProps = {
    appointmentTypes: [],
    website: '',
    locations: [],
  }

  state = {
    apptTypefilterOptions: defaultApptTypeFilterOptions,
    brandName: '',
    contactPhoneNumber: '',
    devCodeCopied: false,
    extraQuestions: [createDeepCopy(defaultExtraQuestion)],
    schedulingWidgetToken: '',
    selectedLocations: [],
    testCodeCopied: false,
    textAreaLabel: '',
    widgetOptions: defaultWidgetOptions,
    messageInWidgetOptions,
    customTimeBoundsStart: null,
    customTimeBoundsEnd: null,
  }

  componentWillMount() {
    const { practiceId, website } = this.props
    const { apptTypefilterOptions } = this.state
    if (
      apptTypefilterOptions &&
      (apptTypefilterOptions[0].apptTypes.length ||
        apptTypefilterOptions[0].button.value)
    ) {
      this.clearApptTypeFields(defaultApptTypeFilterOptions)
      this.setState({ apptTypefilterOptions: defaultApptTypeFilterOptions })
    }
    this.buildSchedulingWidget(website, practiceId)
  }

  buildSchedulingWidget = (website, practiceId) => {
    req.generateWidgetToken(website, practiceId).then(res => {
      const schedulingWidgetToken = res.token
      this.setState({ schedulingWidgetToken })
    })
  }

  clearCopiedState = () =>
    this.setState({ devCodeCopied: false, testCodeCopied: false })

  onOptionSelect = (e, optionCategory) => {
    const option = e.target.value
    const checked = e.target.checked

    if (optionCategory === 'messageOptions') {
      this.setState(prevState => {
        let updatedMessageOptions = {
          ...prevState.messageInWidgetOptions,
          [option]: {
            ...prevState.messageInWidgetOptions[option],
            value: option === 'hideMessageOnMapRow' ? !checked : checked,
          },
        }

        // Ensuring mutual exclusivity
        if (
          (option === 'contactPhoneNumber' && checked) ||
          (option === 'customMessage' && checked)
        ) {
          const otherOption =
            option === 'contactPhoneNumber'
              ? 'customMessage'
              : 'contactPhoneNumber'
          updatedMessageOptions[otherOption].value = false
        }

        return { messageInWidgetOptions: updatedMessageOptions }
      })
    } else {
      // Logic for other widget options
      this.setState(prevState => ({
        widgetOptions: {
          ...prevState.widgetOptions,
          [option]: {
            ...prevState.widgetOptions[option],
            value: checked,
          },
        },
      }))
    }

    this.clearCopiedState()
  }

  onQuestionChange = (e, idx) => {
    const extraQuestions = [...this.state.extraQuestions]
    const extraQuestion = extraQuestions[idx]
    extraQuestion[e.target.name].value = e.target.value
    extraQuestions.splice(idx, 1, extraQuestion)
    this.setState({ extraQuestions }, this.clearCopiedState)
  }

  handleTextInputChange = (e, option) => {
    let inputValue = e.target.value

    // Enforce numeric input for contactPhoneNumber
    if (option === 'contactPhoneNumber') {
      inputValue = inputValue.replace(/[^0-9]/g, '')
    }

    const newMessageOptions = { ...this.state.messageInWidgetOptions }
    newMessageOptions[option].textInput = inputValue
    this.setState({ messageInWidgetOptions: newMessageOptions })
  }

  onBrandNameChange = e => {
    this.setState({ brandName: e.target.value })
  }

  onSpecificLocationsChange = e => {
    this.setState({ selectedLocations: e })
    if (e.length === 0) {
      const { widgetOptions } = this.state
      widgetOptions.sortPerSpecificLocations.value = false
      this.setState({ widgetOptions }, this.clearCopiedState)
    }
  }

  onTextAreaLabelChange = e => {
    this.setState({ textAreaLabel: e.target.value })
  }

  onApptTypeFilterChange = (e, i, type) => {
    const { apptTypefilterOptions: oldapptTypefilterOptions } = this.state
    const apptTypefilterOptions = [...oldapptTypefilterOptions]

    switch (type) {
      case 'input':
        apptTypefilterOptions[i].button.value = e.target.value
        this.setState({ apptTypefilterOptions })
        break
      case 'select':
        apptTypefilterOptions[i].apptTypes.push(e)
        this.setState({ apptTypefilterOptions })
        break
      case 'deselect':
        apptTypefilterOptions[i].apptTypes = apptTypefilterOptions[
          i
        ].apptTypes.filter(item => item !== e)
        this.setState({ apptTypefilterOptions })
        break
      default:
        break
    }
  }

  onCustomTimeBoundsStartChange = e => {
    this.setState({ customTimeBoundsStart: e ? e : null })
  }

  onCustomTimeBoundsEndChange = e => {
    this.setState({ customTimeBoundsEnd: e ? e : null })
  }

  clearApptTypeFields = defaultFilterOptions => {
    defaultFilterOptions.forEach(item => {
      item.apptTypes = []
      item.button.value = ''
    })
  }

  onAddNewOptionClick = () => {
    const { apptTypefilterOptions: oldapptTypefilterOptions } = this.state
    let apptTypefilterOptions = [...oldapptTypefilterOptions]
    apptTypefilterOptions = addFilterOptionButton(apptTypefilterOptions)
    this.setState({ apptTypefilterOptions })
  }

  onDeleteOptionClick = i => {
    const { apptTypefilterOptions } = this.state
    const updatedOptions = apptTypefilterOptions.filter((_, idx) => idx !== i)
    this.setState({ apptTypefilterOptions: updatedOptions })
  }

  copiedToClipboard = whichCopied => {
    this.setState({ [whichCopied]: true })
  }

  handleAddExtraQuestion = () => {
    const extraQuestions = [...this.state.extraQuestions]
    extraQuestions.push(createDeepCopy(defaultExtraQuestion))
    this.setState({ extraQuestions })
  }

  handleDeleteExtraQuestion = () => {
    const extraQuestions = [...this.state.extraQuestions]
    extraQuestions.pop()
    this.setState({ extraQuestions })
  }

  render() {
    const {
      apptTypefilterOptions,
      brandName,
      devCodeCopied,
      extraQuestions,
      schedulingWidgetToken,
      selectedLocations,
      testCodeCopied,
      textAreaLabel,
      widgetOptions,
      messageInWidgetOptions,
      customTimeBoundsStart,
      customTimeBoundsEnd,
    } = this.state

    const { website, locations, appointmentTypes, pms } = this.props

    const showWarning =
      !messageInWidgetOptions.showPhoneMessageOnDropdown.value &&
      messageInWidgetOptions.hideMessageOnMapRow.value &&
      (messageInWidgetOptions.contactPhoneNumber.value ||
        messageInWidgetOptions.customMessage.value)

    const warning = 'Warning: No message will be shown if both "Show in Initial Container" and "Show in Secondary Container" are unchecked, even if a "Custom Message" or "Contact Phone Number" is provided.'

    const instructions = `Navigate to the source code of ${website} and add the following directly above the closing body tag:`

    // Build options string
    const optionsStr = buildOptionsStr(widgetOptions, messageInWidgetOptions)
    const apptTypefilterOptionstr = buildFilterObjStr(apptTypefilterOptions)
    const brandNameStr = buildBrandNameStr(brandName)
    const extraQuestionStr = buildExtraQuestionsStr(extraQuestions)
    const selectedLocationsStr = buildSelectedLocationsStr(selectedLocations)
    const textAreaLabelStr = buildTextAreaLabelStr(textAreaLabel)
    const customTimeBoundsStr = buildCustomTimeBoundsStr(customTimeBoundsStart, customTimeBoundsEnd)

    // Concatenate all options into one string
    const options = optionsStr
      .concat(apptTypefilterOptionstr)
      .concat(brandNameStr)
      .concat(selectedLocationsStr)
      .concat(extraQuestionStr)
      .concat(textAreaLabelStr)
      .concat(customTimeBoundsStr)

    const widgetCode = buildWidgetCode(schedulingWidgetToken, options)
    const isTops = pms === 'topsOrtho'
    const extraQuestionsEligible = ['Cloud9', 'Dolphin'].includes(pms)

    return (
      <div className={css.container}>
        {schedulingWidgetToken && (
          <div>
            <h3>{instructions}</h3>
            <Highlight>{widgetCode}</Highlight>
            <CopyButton
              buttonText="Copy Widget Code to Clipboard"
              copied={devCodeCopied}
              setCopied={() => this.copiedToClipboard('devCodeCopied')}
              strToCopy={widgetCode}
            />
            <Form.Item label="Widget Options" className={formCss.itemLabel}>
              <Row>
                {Object.keys(widgetOptions).map(option => (
                  <Col xl={24} xxl={12} key={option}>
                    <Checkbox
                      value={option}
                      onChange={e => this.onOptionSelect(e)}
                      checked={widgetOptions[option].value}
                      className={formCss.label}
                      disabled={
                        (option === 'sortPerSpecificLocations' &&
                          selectedLocations.length === 0) ||
                        (option === 'skipDateSelection' &&
                          !widgetOptions['zipCodeSearch'].value)
                      }
                    >
                      {widgetOptions[option].label}
                    </Checkbox>
                  </Col>
                ))}
              </Row>
            </Form.Item>
            <OptionalMessageInWidget
              showWarning={showWarning}
              warning={warning}
              messageInWidgetOptions={messageInWidgetOptions}
              onOptionSelect={this.onOptionSelect}
              handleTextInputChange={this.handleTextInputChange}
              css={css}
              formCss={formCss}
            />
            {appointmentTypes.length && !isTops ? (
              <ApptTypeSelection
                appointmentTypes={appointmentTypes}
                apptTypefilterOptions={apptTypefilterOptions}
                onAddNewOptionClick={this.onAddNewOptionClick}
                onApptTypeFilterChange={this.onApptTypeFilterChange}
                onDeleteOptionClick={this.onDeleteOptionClick}
                isTops={isTops}
              />
            ) : (
              <div>
                <p>
                  {isTops
                    ? ''
                    : `To create a custom filter make sure there are Available
                    Appointment Types available to select.`}
                </p>
              </div>
            )}
            {extraQuestionsEligible && (
              <ExtraQuestions
                extraQuestions={extraQuestions}
                handleAddExtraQuestion={this.handleAddExtraQuestion}
                handleDeleteExtraQuestion={this.handleDeleteExtraQuestion}
                onQuestionChange={this.onQuestionChange}
              />
            )}
            <BrandName
              brandName={brandName}
              onChange={this.onBrandNameChange}
            />
            <SpecificLocations
              locations={locations}
              onChange={this.onSpecificLocationsChange}
              selected={selectedLocations}
            />
            <TextAreaLabel
              textAreaLabel={textAreaLabel}
              onChange={this.onTextAreaLabelChange}
            />
            <CustomTimeBounds
              customTimeBoundsStart={customTimeBoundsStart}
              customTimeBoundsEnd={customTimeBoundsEnd}
              onCustomTimeBoundsStartChange={this.onCustomTimeBoundsStartChange}
              onCustomTimeBoundsEndChange={this.onCustomTimeBoundsEndChange}
              css={css}
              formCss={formCss}
            />
            <TestSnippet
              copied={testCodeCopied}
              setCopied={() => this.copiedToClipboard('testCodeCopied')}
              options={options}
              token={schedulingWidgetToken}
            />
          </div>
        )}
      </div>
    )
  }
}

export default SchedulingWidgetSnippet



// WEBPACK FOOTER //
// ./src/AddPractice/Info/SchedulingWidgetSnippet/index.js